import { CoachingLibraryCatalogue } from '@euler/model/coaching';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

export type CoachingCatalogueState =
  | { kind: 'loading' }
  | { kind: 'failed' }
  | { kind: 'ready'; catalogue: CoachingLibraryCatalogue };

/** The library's categories, collections, criteria and tags. */
export function useCoachingCatalogueState(): {
  state: CoachingCatalogueState;
  reload: () => void;
} {
  const { coachingService } = useServiceFactory();
  const [state, setState] = useState<CoachingCatalogueState>({
    kind: 'loading',
  });
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let active = true;
    setState({ kind: 'loading' });
    coachingService
      .getCatalogue()
      .then(catalogue => {
        if (active) setState({ kind: 'ready', catalogue });
      })
      .catch(error => {
        console.error('coaching catalogue failed', error);
        if (active) setState({ kind: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [coachingService, reloadKey]);
  return { state, reload };
}

/** The catalogue; null while it loads, or when it did not load. */
export function useCoachingCatalogue(): CoachingLibraryCatalogue | null {
  const { state } = useCoachingCatalogueState();
  return state.kind === 'ready' ? state.catalogue : null;
}
